
import { createSelector } from '@ngrx/store';

import { AuthState, getAuthState } from './auth.reducer'

export const getAuthData = createSelector(
    getAuthState,
    (authState: AuthState) => authState.authData
);

export const getLoggedIn = createSelector(
    getAuthState,
    (authState: AuthState) => authState.loggedIn
);

export const getLoading = createSelector(
    getAuthState,
    (authState: AuthState) => authState.loading
);

export const getLoadedAt = createSelector(
    getAuthState,
    (authState: AuthState) => authState.loadedAt
);